import { createFileRoute } from '@tanstack/react-router'

import { ClientBilling } from '@/components/billing/client-billing'
import { useShellClient } from '@/components/clients/shell-client'
import { Frame } from '@/components/frame'

export const Route = createFileRoute('/_app/clients/$clientId/facturation')({
  component: ClientBillingPage,
})

function ClientBillingPage() {
  const client = useShellClient()
  return (
    <Frame>
      <ClientBilling clientId={client.id} />
    </Frame>
  )
}
